/**
 * This slice is dedicated to File API data
 * TODO: Migrate usage from CRM to this one
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GetFileByNameCall } from '../../models/file/types';
import { processErrorInReducer } from '../helpers';

export interface FileState {
  files: { [fileName: string]: string };
  error: { [code: number]: string };
  getFileByName: boolean;
  isGettingFile: boolean;
}

export const INITIAL_STATE: FileState = {
  files: {},
  error: {},
  getFileByName: false,
  isGettingFile: false,
};

const fileSlice = createSlice({
  name: 'file',
  initialState: INITIAL_STATE,
  reducers: {
    getIndividualFilesCompleted(state, action) {
      state.files = { ...state.files, ...action.payload.filesContents };
    },
    getIndividualFilesFailed(state, action) {
      processErrorInReducer(state, action);
    },
    deleteFileByNameFailed(state) {
    },
    deleteFileByNameSuccess(state, action) {
      const fileName = action.payload;
      const files = { ...state.files };

      if (typeof files[fileName] !== 'undefined') {
        delete files[fileName];
      }

      state.files = { ...files };
    },
    getFileByName(state: FileState, action: PayloadAction<GetFileByNameCall>) {
      state.getFileByName = false;
      state.isGettingFile = true;
    },
    getFileByNameCancel(state: FileState) {
      state.isGettingFile = false;
    },
    getFileByNameFailed(state: FileState, action) {
      state.getFileByName = false;
      state.isGettingFile = false;
      processErrorInReducer(state, action);
    },
    getFileByNameSuccess(state: FileState, action) {
      state.isGettingFile = false;
      const { customData, data } = action.payload;
      const { fileName } = customData;
      state.files[fileName] = data;
      state.getFileByName = true;
    },
  },
  extraReducers: {
  },
});

export const {
  getIndividualFilesCompleted,
  getIndividualFilesFailed,
  deleteFileByNameFailed,
  deleteFileByNameSuccess,
  getFileByName,
  getFileByNameCancel,
  getFileByNameFailed,
  getFileByNameSuccess,
} = fileSlice.actions;

export default fileSlice.reducer;
